document.addEventListener('DOMContentLoaded', function () {
  var sections = document.querySelectorAll('.cb-stay-connected');

  sections.forEach(function (section) {
    var whatsappForm = section.querySelector('[data-cb-whatsapp-subscribe]');

    if (!whatsappForm) return;

    var submitButton = whatsappForm.querySelector('.cb-stay-connected__submit');
    var phoneInput = whatsappForm.querySelector('input[name="phone"]');
    var honeypotInput = whatsappForm.querySelector('input[name="website"]');
    var statusBox = whatsappForm.querySelector('[data-cb-whatsapp-status]');
    var endpoint = whatsappForm.getAttribute('action');

    var consentText =
      'Get exclusive launches, offers and jewellery updates on WhatsApp or email. Subscribe to your preferred channel below.';

    function showStatus(message, type) {
      if (!statusBox) return;

      statusBox.textContent = message;
      statusBox.hidden = false;
      statusBox.classList.remove('is-success', 'is-error');
      statusBox.classList.add(type === 'success' ? 'is-success' : 'is-error');
    }

    function clearStatus() {
      if (!statusBox) return;

      statusBox.hidden = true;
      statusBox.textContent = '';
      statusBox.classList.remove('is-success', 'is-error');
    }

    whatsappForm.addEventListener('submit', async function (event) {
      event.preventDefault();
      clearStatus();

      if (!endpoint) {
        showStatus('Subscription is currently unavailable. Please try again later.', 'error');
        return;
      }

      if (!phoneInput || !phoneInput.checkValidity()) {
        if (phoneInput) phoneInput.reportValidity();
        return;
      }

      var originalButtonText = submitButton ? submitButton.textContent : '';

      if (submitButton) {
        submitButton.disabled = true;
        submitButton.textContent = 'SAVING...';
      }

      var payload = {
        formType: 'whatsappSubscriber',
        phone: phoneInput.value,
        whatsappConsent: true,
        consentText: consentText,
        website: honeypotInput ? honeypotInput.value : '',
        sourcePage: window.location.href,
        submittedAt: new Date().toISOString()
      };

      try {
        await fetch(endpoint, {
          method: 'POST',
          mode: 'no-cors',
          headers: {
            'Content-Type': 'text/plain;charset=utf-8'
          },
          body: JSON.stringify(payload)
        });

        whatsappForm.reset();

        showStatus(
          'Thank you. You are subscribed for Caratbazaar WhatsApp updates.',
          'success'
        );
      } catch (error) {
        showStatus(
          'Something went wrong. Please try again.',
          'error'
        );
      } finally {
        if (submitButton) {
          submitButton.disabled = false;
          submitButton.textContent = originalButtonText;
        }
      }
    });
  });
});